<template>
  <div>
    <v-row no-gutters class="text-title-small px-6">
      <v-col :cols="columnWidth">
        FIELDS
      </v-col>
      <v-col :cols="columnWidth">
        SOURCE
      </v-col>
      <v-col :cols="columnWidth">
        <div class="d-flex align-end justify-space-between">
          <div v-if="!isReadOnly">
            ENGLISH TRANSLATION
          </div>
          <div v-else>
            CUSTOMER'S TRANSLATION
          </div>
          <div>
            <v-chip v-if="!isReadOnly" id="translate-field-step-3" color="primary" class="font-weight-regular" small>
              {{ completedFieldCount }} OF {{ totalFieldCount }} COMPLETED
            </v-chip>
          </div>
        </div>
      </v-col>
      <v-col v-if="isReadOnly" :cols="columnWidth">
        PROVIDER'S EDIT
      </v-col>
    </v-row>
    <v-divider class="mt-4 mb-6" />
    <div v-for="(field, index) in fields" :key="`field-${index}`">
      <v-row no-gutters class="mt-2 px-6">
        <v-col :cols="columnWidth">
          <div class="mb-4">
            <p class="ma-0 body-1">
              {{ field.field }}
            </p>
            <p v-if="field.original" class="ma-0 body-2">
              ({{ field.original }})
            </p>
          </div>
        </v-col>
        <v-col :cols="columnWidth" class="d-flex">
          <ImageView :id="index === 0 ? 'translate-field-step-1' : undefined" :is-provider-supplied="!field.isCustomerProvided" :path="field.path" :markup-id="field.id" :is-purged="!!field.isDocumentPurged" :can-update="!isReadOnly" class="fs-exclude" />
          <template v-if="field.path && !isReadOnly">
            <v-btn icon :to="`./translate?step=select&markupId=${field.id}`">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn class="mr-3" icon @click="deleteField(field)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-col>
        <v-col :cols="columnWidth" class="d-flex">
          <TranslateInput v-if="field && !isReadOnly" :id="index === 0 ? 'translate-field-step-2' : undefined" :field="field" :last-date-value="lastDateValue" @input="fieldUpdated(field.id, $event)" @setLastDate="setLastDate($event)" />
          <template v-if="field && isReadOnly">
            <span v-if="!field.isDocumentPurged">{{ field.translatedValue || 'N/A' }}</span>
            <span v-else class="font-italic">(redacted)</span>
          </template>
        </v-col>
        <v-col v-if="isReadOnly" :cols="columnWidth">
          <span v-if="!field.isDocumentPurged">{{ field.notApplicable ? 'N/A' : field.correctedValue }}</span>
          <span v-else class="font-italic">(redacted)</span>
        </v-col>
      </v-row>
      <v-divider class="mb-6" />
    </div>
  </div>
</template>

<script>
import ImageView from '@/domains/global/components/ImageView.vue'
import TranslateInput from './TranslateInput.vue'

export default {
  components: {
    ImageView,
    TranslateInput
  },
  props: {
    completedFieldCount: { type: Number, default: 0 },
    fields: { type: Array, default: () => [] },
    isDraft: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      lastDateValue: null
    }
  },
  computed: {
    columnWidth() {
      return this.isReadOnly ? 3 : 4
    },
    totalFieldCount() {
      return this.fields.length
    }
  },
  methods: {
    fieldUpdated(id, data) {
      this.$emit('updateField', { id, ...data })
    },
    deleteField(field) {
      this.$emit('deleteField', field)
    },
    setLastDate(value) {
      this.lastDateValue = value
    }
  }
}
</script>
